// TODO: remove this file once common.js ('Configuration' module) doesn't need it anymore
angular.module('EnvironmentConfiguration', []);